"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageContribution = void 0;
const react_1 = __importDefault(require("react"));
const inversify_1 = require("inversify");
const home_components_1 = require("../../components/home-components");
const lucide_react_1 = require("lucide-react");
const ui_contributions_1 = require("@authlance/core/lib/browser/common/ui-contributions");
function IndexPage() {
    return (react_1.default.createElement(home_components_1.HomeComponent, null));
}
let HomePageContribution = class HomePageContribution {
    constructor(homeContentPreloadProvider, defaultDashboardContentContributor) {
        this.homeContentPreloadProvider = homeContentPreloadProvider;
        this.defaultDashboardContentContributor = defaultDashboardContentContributor;
    }
    getRoute() {
        return {
            path: '/',
            component: IndexPage,
            icon: react_1.default.createElement(lucide_react_1.Home, null),
            navBar: true,
            name: 'Home',
            exact: true,
            root: true,
            authRequired: false,
            prerender: {
                enabled: true,
                preload: async (context) => {
                    if (!context) {
                        return;
                    }
                    await this.homeContentPreloadProvider.preload(context);
                },
                document: (context) => {
                    if (!context) {
                        return Promise.resolve(undefined);
                    }
                    if (this.defaultDashboardContentContributor.getDocumentProvider) {
                        const targetProvider = this.defaultDashboardContentContributor.getDocumentProvider();
                        if (targetProvider) {
                            return targetProvider(context);
                        }
                    }
                    return Promise.resolve(undefined);
                }
            }
        };
    }
};
exports.HomePageContribution = HomePageContribution;
exports.HomePageContribution = HomePageContribution = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ui_contributions_1.HomeContentPreloadProvider)),
    __param(1, (0, inversify_1.inject)(ui_contributions_1.DefaultDashboardContentContributor)),
    __metadata("design:paramtypes", [Object, Object])
], HomePageContribution);
exports.default = IndexPage;
